/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberShiftIdAppointmentsQueryResponse, GetApiBarberShiftIdAppointmentsPathParams, GetApiBarberShiftIdAppointments400, GetApiBarberShiftIdAppointments401, GetApiBarberShiftIdAppointments403, GetApiBarberShiftIdAppointments404, GetApiBarberShiftIdAppointments500 } from "../entities/GetApiBarberShiftIdAppointments";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBarberShiftIdAppointments } from "../api/getApiBarberShiftIdAppointments";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBarberShiftIdAppointmentsQueryKey = (id: GetApiBarberShiftIdAppointmentsPathParams["id"] | undefined) => [{ url: '/api/barber/shift/:id/appointments', params: {id:id} }] as const

export type GetApiBarberShiftIdAppointmentsQueryKey = ReturnType<typeof getApiBarberShiftIdAppointmentsQueryKey>

export function getApiBarberShiftIdAppointmentsQueryOptions(id: GetApiBarberShiftIdAppointmentsPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBarberShiftIdAppointmentsQueryKey(id)
        return queryOptions<GetApiBarberShiftIdAppointmentsQueryResponse, ResponseErrorConfig<GetApiBarberShiftIdAppointments400 | GetApiBarberShiftIdAppointments401 | GetApiBarberShiftIdAppointments403 | GetApiBarberShiftIdAppointments404 | GetApiBarberShiftIdAppointments500>, GetApiBarberShiftIdAppointmentsQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBarberShiftIdAppointments(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получить очередь для рабочего места мастера
 * @summary Получить мою очередь
 * {@link /api/barber/shift/:id/appointments}
 */
export function useGetApiBarberShiftIdAppointments<TData = GetApiBarberShiftIdAppointmentsQueryResponse, TQueryData = GetApiBarberShiftIdAppointmentsQueryResponse, TQueryKey extends QueryKey = GetApiBarberShiftIdAppointmentsQueryKey>(id: GetApiBarberShiftIdAppointmentsPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetApiBarberShiftIdAppointmentsQueryResponse, ResponseErrorConfig<GetApiBarberShiftIdAppointments400 | GetApiBarberShiftIdAppointments401 | GetApiBarberShiftIdAppointments403 | GetApiBarberShiftIdAppointments404 | GetApiBarberShiftIdAppointments500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBarberShiftIdAppointmentsQueryKey(id)
         

         const query = useQuery({
          ...getApiBarberShiftIdAppointmentsQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiBarberShiftIdAppointments400 | GetApiBarberShiftIdAppointments401 | GetApiBarberShiftIdAppointments403 | GetApiBarberShiftIdAppointments404 | GetApiBarberShiftIdAppointments500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}